<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { useStudentStore } from '@/stores/student';

const studentStore = useStudentStore();

const { mdAndUp } = useDisplay();
</script>

<template>
    <VCard to="/activities" class="dashboard-card dashboard-card--activities d-flex flex-column">
        <VCardTitle>
          <p class="dashboard-card__title d-flex flex-column d-md-block text-center text-md-left text-white">
            <span class="mr-md-4"><VIcon icon="mdi-note-edit-outline" :size="mdAndUp ? 36 : 48" /></span>
            <span class="font-museo" :class="`font-${studentStore.fontStyle}`">{{ $t('pages.dashboard.activities.title')  }}</span>
          </p>
        </VCardTitle>
        <VCardText class="align-content-end text-white">
          <VRow>
            <VCol cols="12" md="7" class="d-none d-md-flex flex-column justify-space-between pt-0">
              <p class="dashboard-card__description pt-6 pb-3">
                {{ $t('pages.dashboard.activities.description') }}
              </p>
              <VBtn variant="tonal" rounded="xl" class="dashboard-card__view-btn dashboard-card__view-btn--activities">
                  {{ $t('pages.dashboard.activities.view_btn') }}
              </VBtn>
            </VCol>
            <VCol cols="12" md="5">
              <VImg class="dashboard-card__image" src="@images/dashboard/activities.svg" />
            </VCol>
          </VRow>
        </VCardText>
    </VCard>
</template>
